import React from "react";
import { ReactComponent as NotFoundImage } from "../../assets/media/not-found.svg";

const NotFound = ({ text = "Data not found" }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "400px",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <NotFoundImage />
      <p
        style={{
          fontSize: "21px",
          color: "#082A5180",
          textAlign: "center",
          marginTop: "20px",
          fontWeight: "400",
        }}
      >
        {text}
      </p>
    </div>
  );
};

export default NotFound;
